import http from '../../utils/fetch';
export default {
    querySupplierData(instid) {
        return http({
            url: '/api/swyl/v1/test/ViewUserSupplierController/selectOneByInstid',
            method: 'post',
            params: {instid}
        });
    },
    approveCreate(query) {
        return http({
            url: '/api/swyl/v1/supplier/SupplierController/approveCreate',
            method: 'post',
            data: query
        });
    },
}